import { useQuery } from "@tanstack/react-query";

/**
 * PILOT_MODE (server/pilot.ts): while a few outside businesses test DrPR, pricing, checkout and upgrade screens and prompts are hidden.
 * Read from the public GET /api/public/config (no login needed). `loaded` is false until the answer is in, so a gate that would
 * otherwise send someone to checkout can wait for it instead of flashing a price.
 */
export function usePublicConfig(): { pilotMode: boolean; loaded: boolean } {
  const { data, isSuccess, isError } = useQuery<{ pilotMode?: boolean }>({
    queryKey: ["/api/public/config"],
    staleTime: Infinity,
    retry: 1,
  });
  return { pilotMode: data?.pilotMode === true, loaded: isSuccess || isError };
}

export function usePilotMode(): boolean {
  return usePublicConfig().pilotMode;
}
